import { NextPage } from "next"
import { Seo } from "../components/seo"

const CookiePolicyPage: NextPage = () => {
  return (
    <div className={"container my-16 mx-auto"}>
      <Seo title="Cookie" />
      <article className="prose lg:prose-xl p-10">
        <h3>
          <strong>Perché questa Cookie Policy</strong>
        </h3>
        <p>
          Questa Cookie Policy ha lo scopo di rendere note le procedure seguite
          per la raccolta, tramite i cookie delle informazioni fornite dagli
          utenti tramite il dispositivo che utilizzano per navigare all’interno
          di questo sito web di titolarità della Fondazione Arezzo Intour, con
          sede in Arezzo, Via Albergotti, n. 13 – 52100 Arezzo (di seguito anche
          solo la Fondazione).Il titolare di questo sito web è inoltre il
          Titolare del trattamento dei dati personali raccolti ai sensi del
          Regolamento Europeo 679/2016 e di ogni altra normativa applicabile in
          materia di protezione dei dati personali. La presente policy deve
          essere consultata unitamente alla Privacy policy della Fondazione resa
          disponibile su questo sito web e di cui costituisce parte integrante.
        </p>
        <h3>
          <strong>Cosa sono i cookie</strong>
        </h3>
        <p>
          I cookie sono stringhe di testo di piccole dimensioni che le
          applicazioni visitate dall’Utente inviano al suo terminale
          (solitamente al browser), dove vengono memorizzati per essere poi
          ritrasmessi alle stesse applicazioni alla successiva visita del
          medesimo Utente. Con il termine cookie si vuol far riferimento sia
          agli stessi cookie sia a tutte le tecnologie similari. I cookie sono
          usati per accedere più rapidamente ai servizi online e per migliorare
          la navigazione dell’Utente attraverso il monitoraggio di sessioni, la
          memorizzazione di informazioni degli Utenti, il caricamento più rapido
          dei contenuti, etc.
        </p>
        <h3>
          <strong>Come vengono utilizzati i cookie</strong>
        </h3>
        <p>
          Non viene fatto uso di cookie per la profilazione degli utenti, né
          vengono impiegati altri metodi di tracciamento. Viene invece fatto uso
          di cookie di sessione (non persistenti) in modo strettamente limitato
          a quanto necessario per la navigazione sicura ed efficiente dei siti.
          La memorizzazione dei cookie di sessione nei terminali o nei browser è
          sotto il controllo dell&apos;utente, laddove sui server, al termine
          delle sessioni HTTP, informazioni relative ai cookie restano
          registrate nei log dei servizi, con tempi di conservazione comunque
          non superiori ai sette giorni al pari degli altri dati di navigazione.
        </p>
      </article>
    </div>
  )
}

export default CookiePolicyPage
